module.exports = __webpack_public_path__ + "img/person.0734e742.svg";